import React from "react";
import PropTypes from "prop-types";
// Material imports
import { ThemeProvider } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import VerticalTab from "@limitless/modern/navigation/vertical-tabs/VerticalTabs";
import Grid from "@limitless/modern/layout/Grid";
import { useExpertProfileContext } from "@limitless/expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { RemoteContent } from "@limitless/portal";
import { LoadingSpinner } from "@limitless/portal";
import Paper from "@limitless/modern/surfaces/paper/Paper";
const useStyles = makeStyles(theme => ({
  contentContainer: {
    height: "90vh",
    overflow: "auto",
    width: "calc(100% - 315px)",
    backgroundColor: theme.palette.background.default,
    borderRadius: 16,
    boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
    marginTop: "40px"
  }
}));
const LegalTabs = ({
  tabsLabels,
  tabsContent,
  selectedTab = 0,
  onhandleclick,
  loading
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(selectedTab);
  const {
    isDarkMode
  } = useExpertProfileContext();
  const classes = useStyles();
  React.useEffect(() => {
    setSelectedTabIndex(selectedTab);
  }, [selectedTab, isDarkMode]);
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    sx: {
      backgroundColor: theme => theme.palette.background.default
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(VerticalTab, {
    items: tabsLabels,
    value: selectedTabIndex,
    onChange: (e, i) => {
      setSelectedTabIndex(i);
      onhandleclick(i);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: "40px 48px",
      margin: "40px 48px",
      backgroundColor: theme => theme.background.default
    }
  }, !loading && tabsContent && /*#__PURE__*/React.createElement(RemoteContent, {
    color: theme.palette.secondary.contrastText,
    content: tabsContent,
    wrapWhiteSpace: false,
    container: true
  }), loading && /*#__PURE__*/React.createElement(LoadingSpinner, {
    color: "primary"
  })))));
};
export default LegalTabs;
LegalTabs.propTypes = {
  tabsLabels: PropTypes.array.isRequired,
  tabsContent: PropTypes.string.isRequired,
  selectedTab: PropTypes.number,
  onhandleclick: PropTypes.func,
  loading: PropTypes.bool
};